module.exports = __webpack_public_path__ + "img/onboarding_background.10fa6909.png";